<template>
  <v-dialog fullscreen :value="visible" transition="dialog-bottom-transition">
    <div v-if="visible" class="employee-dashboard-dark">
      <v-container fluid>
        <v-row align="center" class="mb-4">
          <v-col cols="12" md="6">
            <h1 class="text-h4 font-weight-bold">
              <v-btn @click="$emit('close')" class="white mr-2" icon large><v-icon color="secondary">mdi-chevron-left</v-icon></v-btn
              >Mitarbeiter-Dashboard
            </h1>
            <h2 class="text-subtitle-1">Status von Rechten & Mitgliedschaften</h2>
          </v-col>
          <v-col cols="12" md="6" class="d-flex justify-md-end">
            <v-btn color="primary" @click="openStudioPicker()">
              <v-icon left>mdi-store-cog</v-icon>
              Studio wechseln
            </v-btn>
          </v-col>
        </v-row>

        <v-card class="mb-6 filter-bar" flat>
          <v-row align="center" class="pa-2">
            <v-col cols="12" md="6">
              <v-text-field
                v-model="searchQuery"
                label="Mitarbeiter suchen..."
                prepend-inner-icon="mdi-magnify"
                hide-details
                clearable
                solo
                flat
                dark
                background-color="transparent"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="selectedRoles"
                :items="rightGroups"
                label="Nach Rollen filtern"
                multiple
                chips
                deletable-chips
                clearable
                hide-details
                solo
                flat
                dark
                background-color="transparent"
                prepend-inner-icon="mdi-account-key"></v-select>
            </v-col>
          </v-row>
        </v-card>

        <v-row v-if="filteredEmployeeList.length > 0">
          <v-col v-for="employee in filteredEmployeeList" :key="employee._id" cols="12" sm="6" md="4" lg="3">
            <v-card class="employee-card" dark>
              <v-img src="https://source.unsplash.com/random/800x200/?abstract,gradient" height="80px" class="card-banner"></v-img>

              <v-card-title class="d-flex flex-column align-center profile-header">
                <v-avatar v-if="false" size="80" class="profile-avatar">
                  <span class="white--text text-h5">{{ getInitials(employee.firstName, employee.lastName) }}</span>
                </v-avatar>
                <div class="text-center mt-2">
                  <span class="font-weight-bold text-lg-h6">{{ employee.firstName }} {{ employee.lastName }}</span>
                  <div v-if="!employee.email.includes('nomail.roody')" class="text-caption">{{ employee.email }}</div>
                </div>
              </v-card-title>

              <v-card-text class="text-center mt-2">
                <v-chip-group column class="d-flex justify-center flex-wrap">
                  <v-chip v-if="employee.tacMembership && employee.tacMembership.name" class="ma-1" color="teal accent-4">
                    <v-icon left small>mdi-card-account-details-star</v-icon>
                    TAC Abo
                  </v-chip>

                  <v-chip v-else class="ma-1" color="red">
                    <v-icon left small>mdi-cancel</v-icon>
                    TAC Abo
                  </v-chip>

                  <v-chip v-if="employee.groupFitness.courses && employee.groupFitness.courses.length > 0" class="ma-1" color="light-blue accent-3">
                    <v-icon left small>mdi-run-fast</v-icon>
                    Instruktor
                  </v-chip>
                  <v-chip v-if="employee.email.includes('nomail.roody')" class="ma-1" color="red">
                    <v-icon left small>mdi-cancel</v-icon>
                    roody
                  </v-chip>
                </v-chip-group>

                <div v-if="employee.roles && employee.roles.length > 0" class="mt-3">
                  <v-chip v-for="role in employee.roles" :key="role" small outlined class="ma-1">
                    {{ role }}
                  </v-chip>
                </div>

                <div v-else class="mt-3">
                  <v-chip v-for="right in employee.rights" :key="role" small outlined class="ma-1">
                    {{ right }}
                  </v-chip>
                </div>

                <div v-if="employee.rights.length === 0 && employee.roles.length === 0" class="mt-3">
                  <v-chip color="secondary" small class="ma-1"> Keine roody Rollen oder Rechte </v-chip>
                </div>
              </v-card-text>

              <v-card-actions class="justify-center">
                <v-btn text small @click="employee.showDetails = !employee.showDetails">
                  Details
                  <v-icon right>{{ employee.showDetails ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
                </v-btn>
              </v-card-actions>

              <v-expand-transition>
                <div v-show="employee.showDetails">
                  <v-divider></v-divider>
                  <v-card-text class="details-section">
                    <div v-if="employee.tacMembership && employee.tacMembership.name">
                      <p><strong>Abo:</strong> {{ employee.tacMembership.name }}</p>
                      <p><strong>Status:</strong> {{ employee.tacMembership.status }}</p>
                      <p>
                        <strong>Gültig:</strong> {{ formatDate(employee.tacMembership.startDate) }} -
                        {{ formatDate(employee.tacMembership.endDate) }}
                      </p>
                    </div>
                    <div v-if="employee.groupFitness.courses && employee.groupFitness.courses.length > 0">
                      <p><strong>Gibt Stunden in:</strong> {{ getGFCourses(employee) }}</p>
                    </div>
                    <div v-if="!employee.tacMembership.name && employee.groupFitness.courses.length === 0">
                      <p>Keine weiteren Details vorhanden.</p>
                    </div>
                  </v-card-text>
                </div>
              </v-expand-transition>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-else class="text-center mt-16">
          <v-col>
            <v-icon size="80" color="white">mdi-account-search-outline</v-icon>
            <h3 class="mt-4 text-h6">Keine Mitarbeiter gefunden</h3>
            <p class="">Passe deine Suche oder die Filter an.</p>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-dialog>
</template>

<script>
// Das Script bleibt exakt gleich wie in der vorherigen Version.
// Hier zur Vollständigkeit noch einmal einfügen.
import api from "@/api"
import { mapGetters, mapActions, mapState } from "vuex"
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDashboard: false,
      employeeList: [],
      rightGroups: [],
      searchQuery: "",
      selectedRoles: [],
    }
  },
  mounted() {
    if (this.navigationVisible) this.toggleNavigationBarVisibility()
  },
  beforeDestroy() {
    if (!this.navigationVisible) this.toggleNavigationBarVisibility()
  },
  methods: {
    ...mapActions("navigationStoreNotPersisted", ["toggleNavigationBarVisibility", "setNavigationBarText", "setNavigationbarVisibility"]),
    openStudioPicker() {
      window.app.$root.$children[0].showStudioSelection = true
    },
    getGFCourses(employee) {
      return [...new Set(employee.groupFitness.courses.map((e) => e.studioName))].join(", ")
    },
    getInitials(firstName, lastName) {
      const fn = firstName || ""
      const ln = lastName || ""
      return `${fn.charAt(0)}${ln.charAt(0)}`.toUpperCase()
    },
    formatDate(date) {
      if (!date) return "unbekannt"
      const options = { year: "numeric", month: "long", day: "numeric" }
      return new Date(date).toLocaleDateString("de-DE", options)
    },
  },
  watch: {
    async visible(newVal) {
      if (newVal) {
        console.log("Dashboard wird geöffnet")
        try {
          let list = await api.fetchCurrentEmployeeList()
          this.employeeList = list.employeeList.map((e) => ({ ...e, showDetails: false }))
          this.rightGroups = list.rightGroups.sort()
        } catch (error) {
          console.error("Fehler beim Laden der Mitarbeiterliste:", error)
        }
      } else {
        this.employeeList = []
        this.rightGroups = []
        this.selectedRoles = []
        this.searchQuery = ""
      }
    },
  },
  computed: {
    ...mapState("navigationStoreNotPersisted", ["navigationItems", "navigationVisible"]),
    filteredEmployeeList() {
      let employees = [...this.employeeList]
      if (this.searchQuery) {
        const lowerCaseQuery = this.searchQuery.toLowerCase()
        employees = employees.filter(
          (employee) =>
            (employee.firstName?.toLowerCase() || "").includes(lowerCaseQuery) ||
            (employee.lastName?.toLowerCase() || "").includes(lowerCaseQuery) ||
            (employee.email?.toLowerCase() || "").includes(lowerCaseQuery)
        )
      }
      if (this.selectedRoles.length > 0) {
        employees = employees.filter((employee) => this.selectedRoles.every((role) => employee.roles.includes(role)))
      }
      return employees
    },
  },
}
</script>

<style scoped>
.employee-dashboard-dark {
  background-color: #121212;
  color: #e0e0e0;
  min-height: 100vh;
  font-family: "Inter", sans-serif;
}

.gradient-text {
  background: -webkit-linear-gradient(45deg, #42a5f5, #b388ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.filter-bar {
  background: rgba(40, 40, 40, 0.7) !important;
  backdrop-filter: blur(10px) saturate(180%);
  -webkit-backdrop-filter: blur(10px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px !important;
}

.employee-card {
  border-radius: 16px !important;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: linear-gradient(145deg, #1e1e1e, #1a1a1a);
}

.employee-card:hover {
  transform: translateY(-10px) scale(1.02);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5), 0 0 30px rgba(76, 175, 80, 0.2);
}

.profile-header {
  margin-top: -60px;
  padding-bottom: 0;
}

.profile-avatar {
  border: 4px solid #121212;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.4);
  background: linear-gradient(45deg, #42a5f5, #b388ff);
}

.card-banner {
  filter: blur(1px) grayscale(50%);
}

.details-section {
  background-color: rgba(0, 0, 0, 0.2);
  text-align: left;
}
.details-section p {
  margin-bottom: 8px;
}

/* Animations for the list */
.card-fade-enter-active,
.card-fade-leave-active {
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

.card-fade-enter,
.card-fade-leave-to {
  opacity: 0;
  transform: scale(0.9) translateY(20px);
}

.card-fade-move {
  transition: transform 0.6s cubic-bezier(0.55, 0, 0.1, 1);
}
</style>
